import BaseSelectionFeature from "./base-selection-feature";
import {ActionTypeEnum} from "../../base/training-literals";
import {SelectionObjectTypeEnum} from "../action-literals";

class Transparency extends BaseSelectionFeature {
    constructor(props = {}) {
        super(props);
        this.actionType = props.actionType || ActionTypeEnum.TRANSPARENCY;
    }

    startSelection() {
        SelectionData.changeResetOnOutsideClickState(true);
        changeSelectionAction(SelectionActionEnum.Transparency);
        if (this.selectionObjectType === SelectionObjectTypeEnum.Models) {
            onChangeApplyToSelection(false);
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Volumes) {
            onChangeApplyToSelection(true);
        }
    }

    stopSelection() {
        VRMessageController.addMessage({
            text: "Selection Stopped",
            priority: VrMessagePriorityEnum.LOWPRIORITYINFO
        });
        this.set2dElementsVisibility(true);
        onChangeApplyToSelection(true);
        changeSelectionAction(SelectionActionEnum.NONE);
        SelectionData.resetAllSelection()
    }

    selectItems(items, isTransparent) {
        if (this.selectionObjectType === SelectionObjectTypeEnum.Volumes) {
            for (const item of items) {
                performTransparencyOperationOnVolume(item.id, isTransparent);
            }
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Models) {
            for (const item of items) {
                performTransparencyOperationOnModel(item.id, isTransparent);
            }
        }
    }

    sendDataOnSelection(data) {
        let msg = text_selectionObjects;
        this.sendDataToWeb(msg.command, data);
    }
}

export default Transparency;